// removed by extract-text-webpack-plugin
module.exports = {"container":"container___2eFbW","header":"header___2qGDo","searchContainer":"searchContainer___1I_jg","searchIcon":"searchIcon___2Ecom","search":"search___1IvNU","noResult":"noResult___2oL4D","searchAgain":"searchAgain___34rOE","title":"title___XMSgz","catHeader":"catHeader___1q0Em","headerContainer":"headerContainer___1CVAE","displayType":"displayType___Ja9GS","tagLabel":"tagLabel___2lX0u","tagDropdown":"tagDropdown___3lA5Z","headerFilter":"headerFilter___sYieg","loadingIcon":"loadingIcon___eLx1C"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/SearchPage/SearchPage.module.css
// module id = 417
// module chunks = 0